import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  IconButton,
  makeStyles,
  Typography
} from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";
import { Form, Formik } from "formik";
import React from "react";
import { useIntl } from "react-intl";
import { SubmitButton, TextField } from "../../components/formik";
import { updateExhibitor } from "../../ducks/actions";
import useActionRequest from "../../hooks/useActionRequest";

const useStyles = makeStyles(theme => ({
  title: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(3)
  }
}));

const EditExhibitorDialog = ({ id, exhibitor, onClose }) => {
  const intl = useIntl();
  const classes = useStyles();

  const updateExhibitorRequest = useActionRequest({
    action: updateExhibitor
  });

  /* eslint-disable no-unused-vars */
  const onUpdateExhibitor = async (exhibitor, contextActions) => {
    const response = await updateExhibitorRequest({ id, exhibitor });

    if (response.error) {
      /* eslint-disable no-debugger */
      debugger;
      contextActions.setSubmitting(false);
    } else onClose();
  };

  return (
    <Dialog open maxWidth="sm" fullWidth onClose={onClose}>
      <Typography variant="h5" className={classes.title}>
        <strong>
          {intl.formatMessage({
            id: "Exhibitors.EditExhibitorDialog.EditExhibitorProfileInfo",
            defaultMessage: "Edit Exhibitor Profile Info"
          })}
        </strong>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Typography>
      <Formik initialValues={exhibitor} onSubmit={onUpdateExhibitor}>
        <Form>
          <DialogContent>
            <Typography variant="h5">General Infos</Typography>
            <Divider />
            <br />
            <TextField
              name="name"
              variant="outlined"
              label={intl.formatMessage({
                id: "Exhibitors.EditExhibitorDialog.ExhibitorName",
                defaultMessage: "Exhibitor name"
              })}
              fullWidth
            />
            <TextField
              name="description"
              variant="outlined"
              label={intl.formatMessage({
                id: "Exhibitors.EditExhibitorDialog.BriefDescription",
                defaultMessage: "Brief description"
              })}
              multiline
              rows={3}
              fullWidth
            />
            <TextField
              name="profileDescription"
              variant="outlined"
              label={intl.formatMessage({
                id: "Exhibitors.EditExhibitorDialog.CompnayProfile",
                defaultMessage: "Company profile"
              })}
              multiline
              rows={3}
              fullWidth
            />

            <Typography variant="h5">Contacts</Typography>
            <Divider />
            <br />
            <TextField
              name="profileAddress"
              variant="outlined"
              label={intl.formatMessage({
                id: "Exhibitors.EditExhibitorDialog.Address",
                defaultMessage: "Address"
              })}
              fullWidth
            />
            <TextField
              name="profilePhone"
              variant="outlined"
              label={intl.formatMessage({
                id: "Exhibitors.EditExhibitorDialog.PhoneNumber",
                defaultMessage: "Phone number"
              })}
              fullWidth
            />
            <TextField
              name="profileEmail"
              variant="outlined"
              label={intl.formatMessage({
                id: "Exhibitors.EditExhibitorDialog.Email",
                defaultMessage: "Email"
              })}
              fullWidth
            />
            <TextField
              name="websiteUrl"
              variant="outlined"
              label={intl.formatMessage({
                id: "Exhibitors.EditExhibitorDialog.WebsiteURL",
                defaultMessage: "Website URL"
              })}
              fullWidth
            />
            <TextField
              name="instagramUrl"
              variant="outlined"
              label={intl.formatMessage({
                id: "Exhibitors.EditExhibitorDialog.InstagramURL",
                defaultMessage: "Instagram URL"
              })}
              fullWidth
            />
            <TextField
              name="facebookUrl"
              variant="outlined"
              label={intl.formatMessage({
                id: "Exhibitors.EditExhibitorDialog.FacebookURL",
                defaultMessage: "Facebook URL"
              })}
              fullWidth
            />
            <TextField
              name="twitterUrl"
              variant="outlined"
              label={intl.formatMessage({
                id: "Exhibitors.EditExhibitorDialog.TwitterURL",
                defaultMessage: "Twitter URL"
              })}
              fullWidth
            />
            <TextField
              name="youtubeUrl"
              variant="outlined"
              label={intl.formatMessage({
                id: "Exhibitors.EditExhibitorDialog.YoutubeURL",
                defaultMessage: "Youtube URL"
              })}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose}>
              {intl.formatMessage({
                id: "Exhibitors.EditExhibitorDialog.Cancel",
                defaultMessage: "Cancel"
              })}
            </Button>
            <SubmitButton color="primary">
              {intl.formatMessage({
                id: "Exhibitors.EditExhibitorDialog.Save",
                defaultMessage: "Save"
              })}
            </SubmitButton>
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  );
};

export default EditExhibitorDialog;
